import {Pipe} from '@angular/core';
import {DateFormatPipe} from 'ngx-moment';
import * as moment from 'moment';

@Pipe({name: 'localDatetimeFormat'})
// tslint:disable-next-line:use-pipe-transform-interface
export class LocalDatetimeFormatPipe extends DateFormatPipe {

  public transform(value: Date | moment.Moment | string | number, defaultValue = '', dateFormat = 'LLL'): string {
    if (value == null) {
      return defaultValue;
    }
    let result = super.transform(value, dateFormat);

    if (result.length === 0) {
      result = defaultValue;
    }

    return result;
  }

}
